import type { MatchState, TeamIdx } from '@fafi/shared';

// D164 — the kickabout empties the opposition. D45 made opposing outfielders passive dummies (ZERO
// input) so a solo player had something to dribble at; the playtests read them as broken ("stale
// opposite players" — statues at kickoff spots). The kickabout is a warm-up against their keeper, so
// the outfield dummies leave the pitch entirely.
//
// PURE (this package's contract): a deterministic mutation of MatchState, no I/O, no rng. The client
// re-asserts it every tick of a plain kickabout, because the rules engine re-places the full XI at
// every restart — a one-time park would resurrect the statues at the first goal.
//
// Why so far out: restart-taker routing picks the NEAREST player of the awarded team. Their keeper is
// at worst one pitch diagonal from any spot; a parked body farther than that from the whole pitch can
// never be picked, so on a walled pitch (≤ 5-a-side, no throw-ins, keeper restarts after goals —
// phase.ts D43) every opposition restart lands on the keeper, who plays. Size 11 keeps its full XI:
// its centre kickoff NEEDS an outfielder, so the empty-opposition mode is walled-sizes only.

/** Park x — beyond 2× every walled pitch diagonal (pinned by test). y fans per entity id. */
export const KICKABOUT_PARK = -220;

/** Park `team`'s OUTFIELDERS far off the pitch; their keeper (and everyone else) is untouched. */
export function parkOpponentOutfielders(s: MatchState, playerTeam: TeamIdx, park = KICKABOUT_PARK): void {
  const bench: TeamIdx = playerTeam === 0 ? 1 : 0;
  for (const p of s.players) {
    if (p.team !== bench || p.isGk) continue;
    p.pos = { x: park, y: Math.abs(park) + p.id };
    p.vel = { x: 0, y: 0 };
    p.action = 'IDLE';
    p.actionTicks = 0;
    p.charge = null;
    p.sprinting = false;
  }
}
